// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        utils: {}
    };

} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';

    const needsReview = {};

    needsReview.flags = {
        NONE: 0,
        NAME: 1,
        // 2 is defunct
        TWITTER: 4,
        FACEBOOK: 8,
        LINKEDIN: 16,
        // 32 is defunct
        YOUTUBE: 64,
        INSTAGRAM: 128,
        DOMAIN: 256,
        // 512 is defunct
        TIKTOK: 1024,

        ALL: 1501 // NOTE must be the sum of all flags above
    };

    needsReview.convertBitfieldToObject = function (bitfield) {

        const retObj = {};
        retObj.name = (bitfield & needsReview.flags.NAME) > 0;
        retObj.twitter = (bitfield & needsReview.flags.TWITTER) > 0;
        retObj.facebook = (bitfield & needsReview.flags.FACEBOOK) > 0;
        retObj.linkedin = (bitfield & needsReview.flags.LINKEDIN) > 0;
        retObj.youtube = (bitfield & needsReview.flags.YOUTUBE) > 0;
        retObj.instagram = (bitfield & needsReview.flags.INSTAGRAM) > 0;
        retObj.tiktok = (bitfield & needsReview.flags.TIKTOK) > 0;
        retObj.domain = (bitfield & needsReview.flags.DOMAIN) > 0;

        return retObj;
    };

    needsReview.convertObjectToBitfield = function (o) {

        let retVal = 0;
        if (o.name) {
            retVal += needsReview.flags.NAME;
        }
        if (o.twitter) {
            retVal += needsReview.flags.TWITTER;
        }
        if (o.facebook) {
            retVal += needsReview.flags.FACEBOOK;
        }
        if (o.linkedin) {
            retVal += needsReview.flags.LINKEDIN;
        }
        if (o.youtube) {
            retVal += needsReview.flags.YOUTUBE;
        }
        if (o.instagram) {
            retVal += needsReview.flags.INSTAGRAM;
        }
        if (o.tiktok) {
            retVal += needsReview.flags.TIKTOK;
        }
        if (o.domain) {
            retVal += needsReview.flags.DOMAIN;
        }

        return retVal;
    };

    needsReview.convertBitFieldToNameList = function (bitfield) {

        const obj = needsReview.convertBitfieldToObject(bitfield);
        const fields = [];
        Object.keys(obj).forEach(function (field) {
            if (obj[field]) {
                fields.push(field);
            }
        });

        return fields;
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = needsReview;
    } else {
        RivalIQ.utils.needsReview = needsReview;
    }

})();
